const genSpaceCompactStyle = (token) => {
    const { componentCls } = token;
    return {
        [componentCls]: {
            '&-block': {
                display: 'flex',
                width: '100%',
            },
            '&-vertical': {
                flexDirection: 'column',
            },
        },
    };
};
// ============================== Export ==============================
export default genSpaceCompactStyle;
